import { render } from "./ChatButton.vue?vue&type=template&id=8030ced0&scoped=true"
import script from "./ChatButton.vue?vue&type=script&lang=js"
export * from "./ChatButton.vue?vue&type=script&lang=js"

import "./ChatButton.vue?vue&type=style&index=0&id=8030ced0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8030ced0"

export default script